import React from 'react'
import { RealEstateCategory, Salutation, SegmentationType, TransactionType } from '../../../../../@types/types'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { AGENT_GASTRONOMY_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import {
  SCREEN_ADDRESS,
  SCREEN_API_SEARCH_DATA,
  SCREEN_CONNECTIONS,
  SCREEN_CONSTRUCTION,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREEN_OBJECT_NUMBERS,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Construction from '../../../../../components/pages/insertionPage/screens/construction/Construction'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'
import {
  gastronomyRentBasicInfoScreen,
  gastronomyRentOtherFacilitiesScreen,
} from '../../propertyOwner/gastronomy/propertyOwnerGastronomyRentFlow'
import { ObjectNumbersScreen } from '../../../../../components/pages/insertionPage/screens/objectNumber/ObjectNumbersScreen'
import ApiSearchData from '../../../../../components/pages/insertionPage/screens/apiSearchData/ApiSearchData'
import { courtageInformationToApi } from '../../../../../api/realEstate/converters/toApi/estate/courtageInformation/courtageInformationToApi'
import { apiSearchDataToApi } from '../../../../../api/realEstate/converters/toApi/estate/apiSearchData/apiSearchDataToApi'
import { agentGastronomyRentSchema } from './agentGastronomyRentSchema'

const agentGastronomyRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  {
    screen: SCREENS[SCREEN_OBJECT_NUMBERS],
    element: (props) => <ObjectNumbersScreen {...props} />,
  },
  gastronomyRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent
        {...props}
        hasMoveInDate={true}
        showCourtage={true}
        screenTooltip='tooltip.screens.costs.allRent'
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => (
      <Description
        {...props}
        hasFurnishingNote={true}
        hasLocationNote={true}
        hasOtherNote={true}
        hasHomeStreetHome={true}
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[
          MultimediaUploaderType.PICTURE,
          MultimediaUploaderType.FLOOR_PLAN,
          MultimediaUploaderType.DOCUMENT,
          MultimediaUploaderType.VIDEO,
        ]}
        allowMultimediaLinks={true}
      />
    ),
  },
  gastronomyRentOtherFacilitiesScreen,
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONSTRUCTION],
    element: (props) => <Construction {...props} hasLastModernizationField={true} />,
  },
  {
    screen: SCREENS[SCREEN_API_SEARCH_DATA],
    element: (props) => <ApiSearchData {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} hasContactManager={true} />,
  },
]

export const agentGastronomyRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.agent',
    estateType: 'wizard.navigation.header.gastronomy',
    offerType: 'wizard.navigation.header.rents',
    path: AGENT_GASTRONOMY_RENT_FLOW_PATH,
    name: FlowName.AGENT_GASTRONOMY_RENT,
    validationSchema: agentGastronomyRentSchema,
    courtageToApiMapper: courtageInformationToApi,
    apiSearchDataToApiMapper: apiSearchDataToApi,
    metaData: {
      category: RealEstateCategory.GASTRONOMY,
      segmentation: SegmentationType.AGENT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: {
    hideStreetAndStreetNumber: false,
    salutation: Salutation.NO_SALUTATION,
  },
  flowScreens: agentGastronomyRentFlowScreens,
}
